import Direction from "views/logic/aggregationbuilder/Direction";
import SortConfig from "views/logic/aggregationbuilder/SortConfig";
import generateId from "logic/generateId";
import SortsConfiguration from "./SortsConfiguration";
const hasErrors = (errors) => errors.filter((error) => Object.keys(error).length > 0).length > 0;
const validateSorts = (values) => {
  const errors = {};
  if (!values.sort) {
    return errors;
  }
  const sortErrors = values.sort.map((sort) => {
    var _a;
    const sortError = {};
    if (!sort.field || sort.field === "") {
      sortError.field = "Field is required.";
    }
    if (!sort.direction) {
      sortError.direction = "Direction is required.";
    }
    const timeRowExists = !!((_a = values.groupBy) == null ? void 0 : _a.groupings.find((g) => g.direction === "row" && g.type === "time"));
    const nonDataTableVisExists = values.visualization && values.visualization.type !== "table";
    if (timeRowExists && nonDataTableVisExists) {
      sortError.field = "Sort on non data table with time based row grouping does not work.";
    }
    return sortError;
  });
  return hasErrors(sortErrors) ? { sort: sortErrors } : {};
};
const addRandomId = (baseSort = {}) => ({
  ...baseSort,
  id: generateId()
});
const configTypeToFormValueType = (type) => {
  switch (type) {
    case "pivot":
      return "groupBy";
    case "series":
      return "metric";
    default:
      throw new Error(`Invalid sort type: ${type}`);
  }
};
const formValueTypeToConfigType = (type) => {
  switch (type) {
    case "groupBy":
      return "pivot";
    case "metric":
      return "series";
    default:
      throw new Error(`Invalid sort type: ${type}`);
  }
};
const SortElement = {
  title: "Sort",
  key: "sort",
  order: 3,
  allowCreate: () => true,
  onCreate: (formValues) => ({
    ...formValues,
    sort: [...formValues.sort, addRandomId({})]
  }),
  component: SortsConfiguration,
  fromConfig: (config) => ({
    sort: config.sort.map(
      (s) => {
        var _a;
        return addRandomId({
          type: configTypeToFormValueType(s.type),
          field: s.field,
          direction: (_a = s.direction) == null ? void 0 : _a.direction
        });
      }
    )
  }),
  toConfig: (formValues, configBuilder) => configBuilder.sort(
    formValues.sort.map(
      (sort) => new SortConfig(formValueTypeToConfigType(sort.type), sort.field, Direction.fromString(sort.direction))
    )
  ),
  onRemove: (index, formValues) => ({
    ...formValues,
    sort: formValues.sort.filter((_value, i) => index !== i)
  }),
  validate: validateSorts,
  isEmpty: (formValues) => (formValues != null ? formValues : []).length === 0
};
export default SortElement;
